import { get } from "./httpClient";
import type { GradeMaterialsApiResponse } from "@/ts/interfaces/material/api/gradeMaterialsApiInterfaces";

export const gradeMaterialsApi = {
  getGradeMaterials: (gradeId: number): Promise<GradeMaterialsApiResponse> => {
    return get<GradeMaterialsApiResponse>(`/course/grade/${gradeId}/materials`);
  }
};
